import { usePaymentsStatusQuery } from "../../query/payments/queries";
import { selectorDefaultCurrency } from "../selectors/selectorDefaultCurrency";

export function useDefaultCurrency() {
  const paymentsStatusQuery = usePaymentsStatusQuery();
  return selectorDefaultCurrency(paymentsStatusQuery.data);
}
